import { APICore } from './apiCore';

const api = new APICore();

// ─── Helper to get workspace header ───────────────────────────────
const workspaceHeader = (workspaceId?: number | string) =>
    workspaceId ? { headers: { 'X-Workspace-ID': String(workspaceId) } } : {};

// ─── Workspace CRUD ───────────────────────────────────────────────

/** List all workspaces for the authenticated user */
function getWorkspaces() {
    return api.get('/workspaces/');
}

/** Create a new business workspace */
function createWorkspace(data: { workspace_name: string; workspace_slug?: string }) {
    return api.create('/workspaces/', data);
}

/** Switch to a different workspace */
function switchWorkspace(workspaceId: number) {
    return api.create('/workspaces/switch/', { workspace_id: workspaceId });
}

/** Get the current active workspace (requires X-Workspace-ID header) */
function getCurrentWorkspace(workspaceId: number | string) {
    return api.get('/workspaces/current/', undefined);
}

// ─── Members ──────────────────────────────────────────────────────

/** Get members list for a workspace */
function getMembers(workspaceId: number | string) {
    return api.get('/workspaces/members/');
}

/** Invite a user to the workspace */
function inviteMember(data: { email: string; role: string }, workspaceId: number | string) {
    return api.create('/workspaces/invite/', data);
}

/** Remove a member from the workspace */
function removeMember(userId: number) {
    return api.delete(`/workspaces/member/${userId}/`);
}

/** Update a member's role */
function updateMemberRole(data: { user_id: number; role: string }) {
    return api.create('/workspaces/member/role/', data);
}

/** Cancel a pending invitation */
function cancelInvitation(invitationId: number) {
    return api.delete(`/workspaces/invitation/${invitationId}/`);
}

// ─── Invitations ──────────────────────────────────────────────────

/** Accept a workspace invitation via token */
function acceptInvitation(token: string) {
    return api.get(`/invitations/accept/${token}/`);
}

export {
    getWorkspaces,
    createWorkspace,
    switchWorkspace,
    getCurrentWorkspace,
    getMembers,
    inviteMember,
    removeMember,
    updateMemberRole,
    cancelInvitation,
    acceptInvitation,
};
